<template>
  <component
    :is="componentType"
    v-bind="$attrs"
    class="inline-block rounded-md py-1.5 font-semibold disabled:opacity-30 disabled:cursor-not-allowed px-2 outline-hidden transition-all duration-200 ease-in-out"
    :class="{
      'min-w-max': !lineBreak,
      'w-full': block,
      'bg-blue text-gray-300 hover:bg-blue-dark hover:text-white': color === 'primary',
      'bg-gray-400 hover:bg-blue hover:text-white' : color === 'secondary',
      'bg-error text-white hover:bg-error-dark ring-1 ring-error-dark hover:ring-error': color === 'error',
      'bg-gray-100 text-blue hover:text-blue-dark ring-1 ring-gray-400 hover:ring-blue' : color === undefined,
      'opacity-50': loading,
      'py-0.5! px-1 text-sm': dense,
      'w-36': !dense && !block
    }"
    :disabled="isDisabled"
    :to="to"
    :type="buttonType"
  >
    <div
      class="flex justify-center items-center gap-x-1"
      :class="lineBreak && 'w-full'"
    >
      <CarvisSpinner
        v-if="loading"
        class="w-4 h-4"
      />
      <slot
        v-else
        name="icon"
      />
      <span :class="{ 'text-wrap': lineBreak, 'hidden md:inline': hideTextOnMobile }">
        <slot />
      </span>
    </div>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

const props = defineProps<{
  color?: 'primary' | 'secondary' | 'error'
  type?: 'submit'
  block?: boolean
  loading?: boolean
  disabled?: boolean
  dense?: boolean
  lineBreak?: boolean
  hideTextOnMobile?: boolean
  to?: RouteLocationRaw
}>()

const isLink = computed(() => !!props.to)
const componentType = computed(() => isLink.value ? 'router-link' : 'button')
const isDisabled = computed(() => isLink.value ? undefined : (props.disabled || props.loading))
const buttonType = computed(() => isLink.value ? undefined : (props.type ?? 'button'))
</script>
